/**
 * Extracts error message from API error response.
 * Backend may return errMessage (dev), message (prod), or data (string).
 */
export const getErrorMessage = (error, fallback = "An error occurred") => {
  if (!error) return fallback;
  if (error?.message === "Network Error") return error.message;
  const data = error?.response?.data;
  if (typeof data === "string") return data;
  return data?.errMessage ?? data?.message ?? data?.data ?? fallback;
};
